export default "__VITE_ASSET__BICnSMCY__"